var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import AlertCard from '@/components/alert-card/AlertCard';
import SkillSetRow from '@/components/skill-set-row/SkillSetRow';
import CreateSkillsetDialog from '@/components/create-skillset-dialog/CreateSkillsetDialog';
import { SkillCategory, SkillCategoryIncludes } from '@/models/SkillCategory';
import ErrorHandler from '@/support/ErrorHandler';
import { RolesEnum } from '@/items/Roles';
let SkillSets = class SkillSets extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'SkillSets';
        this.isLoading = true;
        this.skillCategories = null;
        this.isCreatingSkillSet = false;
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchSkillCategories();
        this.isLoading = false;
    }
    closeCreateSkillSetDialog() {
        this.isCreatingSkillSet = false;
    }
    // Asyncs
    async fetchSkillCategories() {
        try {
            this.skillCategories = await new SkillCategory()
                .include([SkillCategoryIncludes.SKILLS])
                .all();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async skillCategoryCreated() {
        this.isCreatingSkillSet = false;
        await this.fetchSkillCategories();
    }
    // Getters
    get breadcrumbs() {
        return [{ name: this.$tc('library.title'), path: '/curricula' }];
    }
    get canCreateSkillSets() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.TEACHER]);
    }
    get canViewPage() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.BOARD, RolesEnum.TEACHER]);
    }
};
SkillSets = __decorate([
    Component({
        components: {
            AlertCard,
            PageHeader,
            SkillSetRow,
            CreateSkillsetDialog,
        },
    })
], SkillSets);
export default SkillSets;
